/**
 * Frontend logic for Foxtrot Tabs V2
 */
(function() {
    /**
     * Initializes all tabs blocks found on the page.
     */
    const initTabs = () => {
        const tabBlocks = document.querySelectorAll('.tabs-v2-block:not(.is-editor)');

        tabBlocks.forEach((block) => {
            const buttons = block.querySelectorAll('.tab-btn');
            // Select direct group panels to avoid interference with nested blocks
            const panels = block.querySelectorAll('.tabs-content-panels > .wp-block-group');

            /**
             * Updates active states and accessibility attributes.
             * @param {number} activeIndex 
             */
            const switchTab = (activeIndex) => {
                buttons.forEach((btn, i) => {
                    const isActive = i === activeIndex;
                    btn.classList.toggle('is-active', isActive);
                    btn.setAttribute('aria-selected', isActive);
                    btn.setAttribute('tabindex', isActive ? '0' : '-1');
                });

                panels.forEach((panel, i) => {
                    const isActive = i === activeIndex;
                    panel.style.display = isActive ? 'block' : 'none';
                    panel.setAttribute('hidden', !isActive);
                });
            };

            // Initial setup for ARIA and hidden states
            panels.forEach((panel, i) => {
                panel.setAttribute('role', 'tabpanel');
                if (i !== 0) {
                    panel.style.display = 'none';
                    panel.setAttribute('hidden', 'true');
                }
            });

            // Bind click and keyboard events
            buttons.forEach((button, i) => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    switchTab(i);
                });

                // Support for arrow key navigation within the tablist
                button.addEventListener('keydown', (e) => {
                    let nextIndex = null;
                    if (e.key === 'ArrowRight') nextIndex = (i + 1) % buttons.length;
                    if (e.key === 'ArrowLeft') nextIndex = (i - 1 + buttons.length) % buttons.length;

                    if (nextIndex !== null) {
                        buttons[nextIndex].focus();
                        switchTab(nextIndex);
                    }
                });
            });
        });
    };

    // Execute initialization once the DOM is ready
    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', initTabs);
    } else {
        initTabs();
    }
})();